import styles from './LeftMenu.module.scss';

type PGDClassGetter = (priority: number) => string | undefined;

export const createPriorityGroupDelimiterClassGetter = (): PGDClassGetter => {
  let currentPriority: number;

  return (priority: number): string | undefined => {
    if (typeof currentPriority === 'undefined') {
      currentPriority = priority;
      return;
    }

    if (priority === currentPriority) {
      return;
    }

    currentPriority = priority;

    return styles.nextPriorityGroup;
  };
};
